<template>
    <FullCalendar ref="calendar" :options="calendarOptions" />
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
    props: ["alerts", "user"],
    components: {
        FullCalendar
    },
    data() {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: "dayGridMonth",
                contentHeight: 500,
                dayMaxEventRows: true,
                headerToolbar: {
                    start: "prev,today,next",
                    center: "title",
                    end: "dayGridMonth,dayGridWeek,dayGridDay"
                },
                buttonText: {
                    today: "Today",
                    month: "Month",
                    week: "Week",
                    day: "Day"
                },
                events: this.alertEvents,
                views: {
                    dayGridMonth: {
                        dayMaxEventRows: 6
                    },
                    dayGridWeek: {
                        dayMaxEventRows: 31
                    },
                    dayGridDay: {
                        dayMaxEventRows: 31
                    }
                },
                eventClick: this.showAlertDetails,
                eventContent: arg => {
                    const alert = arg.event.extendedProps.alert;
                    const el = document.createElement("div");
                    let link = '';

                    if (alert.placement) {
                        link = `<a href="/placement/edit/${alert.placement.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.placement.policyholder.name}</a>`;
                    } else if (alert.parent_type === 'App\\Company' && alert.parent) {
                        link = `<a href="/crm/company/${alert.parent.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent.name}</a>`;
                    } else if (alert.parent_type === 'App\\Contact' && alert.parent) {
                        link = `<a href="/crm/contact/${alert.parent.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent.name}</a>`;
                    } else if (alert.parent_type === 'App\\Event' && alert.parent) {
                        link = `<a href="/crm/event/${alert.parent.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent.name}</a>`;
                    } else if (alert.parent_type === 'App\\Vendor' && alert.parent) {
                        link = `<a href="/crm/vendor/${alert.parent.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent.name}</a>`;
                    } else if (alert.parent_type === 'App\\Hotel' && alert.parent) {
                        link = `<a href="/crm/hotel/${alert.parent.id}" class="alert-linked px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent.name}</a>`;
                    } else {
                        link = `<span class="px-2 overflow-ellipsis w-50 text-center text-white bg-secondary">${alert.parent ? alert.parent.name : (alert.custom_item || "-")}</span>`;
                    }

                    el.classList.add("d-flex", "overflow-hidden");
                    el.innerHTML = `${link}<span class="alert-update px-2 overflow-ellipsis w-50 text-center text-warning bg-dark">${alert.name}</span>`;

                    return { domNodes: [el] };
                }
            }
        };
    },
    methods: {
        alertEvents(info, successCallback, failureCallback) {
            successCallback(
                this.alerts.map(alert => {
                    const name = alert.placement && alert.placement.policyholder ? alert.placement.policyholder.name : (alert.parent ? alert.parent.name : alert.custom_item);
                    return {
                        title: `${name} - ${alert.name}`,
                        start: moment(alert.reminder_date).format("YYYY-MM-DD"),
                        extendedProps: { alert, user: this.user }
                    }
                })
            );
        },
        showAlertDetails(e) {
            if (e.jsEvent.target.classList.contains("alert-linked")) {
                e.jsEvent.stopPropagation();
                return;
            }

            const data = e.event.extendedProps;

            window.app_data.activeAlert = { ...data.alert };
            window.app_data.activeAlertUser = { ...data.user };
            window.app_data.updatingAlert = false;
            window.app_data.completingAlert = false;
            window.app_data.updateType = [];
            $('.alert-datepicker').val(data.alert.reminder_date);

            if (data.alert.parent_type) {
                const id = data.alert.placement ? data.alert.placement_id : data.alert.parent_id;
                const name = data.alert.placement ? data.alert.placement.policyholder.name : data.alert.parent.name;
                let model = data.alert.parent_type.replace('App\\', '').toLowerCase();
                if (!['contact', 'company', 'vendor', 'hotel', 'event'].includes(model)) {
                    model = 'placement';
                }
                $(`[data-type="editor-update_alert"] .alert-item-${model} [name="parent_id"]`)
                    .append('<option value="' + id + '">' + name + '</option>')
                    .val(id.toString())
                    .trigger("change")
                    .trigger("change");
            }
            $('[data-type="editor-update_alert"] [name="alert_template_id"]')
                .val(data.alert.name)
                .trigger("change")
                .trigger("change");
            $('[data-type="editor-update_alert"] [name="user_id"]')
                .val(data.alert.user_id.toString())
                .trigger("change")
                .trigger("change");
            popup_open("editor-update_alert");
        }
    },
    watch: {
        alerts: {
            handler: function() {
                const [
                    eventSource
                ] = this.$refs.calendar.getApi().getEventSources();
                eventSource.refetch();
            },
            deep: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/alerts/alert-calendar.vue